import { useState } from "react";
import Btnslider from "./button/BtnSlider";
import dataGuru from "./button/DataGuru";
import Fade from 'react-reveal/Fade';
export const Team = (props) => {
	const [slideIndex, setSlideIndex] = useState(1);

	const nextSlide = () => {
		if (slideIndex !== dataGuru.length) {
			setSlideIndex(slideIndex + 1);
		} else if (slideIndex === dataGuru.length) {
			setSlideIndex(1);
		}
	};

	const prevSlide = () => {
		if (slideIndex !== 1) {
			setSlideIndex(slideIndex - 1);
		} else if (slideIndex === 1) {
			setSlideIndex(dataGuru.length);
		}
	};

	const moveDot = (index) => {
		setSlideIndex(index);
	};
	return (
		<div id="team" className="text-center">
			<div className="container">
				<div className="row">
					<Fade bottom distance="20%" duration={1500}>
					<div className="col-md-8 col-md-offset-2 section-title">
						<h2>Staf Sekolah</h2>
					</div>
					</Fade>
					<Fade bottom distance="20%" duration={1500}>
					<div className="row">
						<div className="col-md-8 col-md-offset-2">
							<div className="container-slider">
								{dataGuru.map((obj, index) => {
									return (
										<div>
											<div
												key={obj.id}
												className={
													slideIndex === index + 1
														? "slide active-anim"
														: "slide"
												}
											>
												<img
													alt="petunjuk"
													src={
														process.env.PUBLIC_URL +
														`/img/team/${index + 1}.jpg`
													}
												/>
											</div>
										</div>
									);
								})}
							</div>
						</div>
					</div>
					</Fade>
				</div>
				<Fade bottom distance="20%" duration={1500}>
				<div className="row">
					<div className="col-md-8 col-md-offset-2 ">
						<Btnslider moveSlide={nextSlide} direction={"next"} />
						<Btnslider moveSlide={prevSlide} direction={"prev"} />

						<div className="container-dots">
							{Array.from({ length: 8 }).map((item, index) => (
								<div
									onClick={() => moveDot(index + 1)}
									className={slideIndex === index + 1 ? "dot active" : "dot"}
								></div>
							))}
						</div>
					</div>
				</div>
				<br />
				<br />
				<div className="row">
					<div className="col-md-8 col-md-offset-2">
						{/* nama guru */}
						<div>
							{dataGuru.map((obj, index) => {
								return (
									<div
										key={obj.name}
										className={
											slideIndex === index + 1 ? "slide active-anim" : "slide"
										}
									>
										<span className="h1 mt-1">{obj.name}</span>
									</div>
								);
							})}
						</div>
					</div>
				</div>
				<br />
				<br />
				<div className="row ">
					<div className="col-md-8 col-md-offset-2 ">
						{/* namajabatan */}
						<div className="">
							{dataGuru.map((obj, index) => {
								return (
									<div
										key={obj.job}
										className={
											slideIndex === index + 1 ? "slide active-anim" : "slide"
										}
									>
										<span className="h3">{obj.job}</span>
									</div>
								);
							})}
						</div>
					</div>
				</div>
				</Fade>
			</div>
		</div>
	);
};
